"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./KYCConfirmMitekModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('kyc-confirm-mitek');
var KYCConfirmMitekModal = function KYCConfirmMitekModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("kyc"),
    t = _useTranslation.t;
  var onConfirm = props.onConfirm,
    close = props.close,
    isOpen = props.isOpen;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t("Confirm Identification Documents"),
    close: close,
    footer: {
      buttonText: t("Confirm"),
      onClick: onConfirm,
      overrideClose: true
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    className: classes('description')
  }, t("Thanks for applying to increase your Verification Level. Once we have reviewed and approved your documents, you will be able to use all features of our platform."))));
};
KYCConfirmMitekModal.propTypes = {
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func.isRequired,
  onConfirm: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = KYCConfirmMitekModal;